import { render, staticRenderFns } from "./baseUploadNew.vue?vue&type=template&id=16f2b4d7&"
import script from "./baseUploadNew.vue?vue&type=script&lang=js&"
export * from "./baseUploadNew.vue?vue&type=script&lang=js&"
import style0 from "./baseUploadNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports